<template>
    <!-- <el-dialog
        custom-class="user-org-dialog"
        title="选择流程"
        top="4vh"
        width="95%"
        :visible.sync="isInnerShowUserOrg"
        append-to-body
      >  -->
      <div>
        <el-container class="userOrgPop">
              <!-- <el-aside width="200px">
                    <el-header height="35px">业务分类</el-header>
                    <BusinessTree
                        v-if="isShowTree"
                        :data="treeData"
                        :defaultProps="defaultProps"
                        @nodeClick="handleTreeNode"
                    />
              </el-aside> -->
              <el-main>
                  <el-container>
                      <el-aside style="width: 60%">
                          <el-form :model="processInstanceModel"  ref="processInstanceForm" size="mini" label-width="120px">
                            <!-- <span><el-tag type="primary">流程列表</el-tag></span> -->
                              <el-row>
                                <el-col :span="9" >
                                  <el-form-item label="流程名称">
                                    <el-input  maxlength="100" v-model.trim="processName" placeholder="流程名称">
                                        <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                                    </el-input>
                                  </el-form-item>
                                </el-col>  
                               <el-col :span="7" >
                                <el-form-item label="流程模板">
                                  <el-select  :key="loadTimer" style="width: 150px;" v-model="processServiceId" clearable  @change="changeProcessList"  placeholder="请选择">
                                      <el-option
                                          v-for="(item,index) in currentTemplateList"
                                          :key="index"
                                          :label="item.templateName"
                                          :value="item.processServiceId">
                                      </el-option>
                                  </el-select>
                                </el-form-item>
                             </el-col>
                              <el-col :span="6" >
                                <el-form-item label="流程状态">
                                  <el-select style="width: 150px;" @change="changeProcessList" v-model="pState" placeholder="请选择">
                                      <el-option
                                          v-for="item in processState"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                      </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                          </el-row>
                        </el-form>
                          <template v-if="multiple">
                              <el-table  :data="processListInBusiness" @selection-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column type="selection" width="55"></el-table-column>
                                  <el-table-column prop="name" label="流程名称" :show-overflow-tooltip="true"></el-table-column>
                                  <el-table-column   label="流程状态" >
                                    <template slot-scope="scope">
                                        <el-tag type="success" v-if="scope.row.hasOwnProperty('endTime')" >已完成</el-tag>
                                        <el-tag  v-else >进行中</el-tag>
                                    </template> 
                                  </el-table-column>
                              </el-table>
                          </template>
                            <template v-else> 
                                <el-table  :data="processListInBusiness" highlight-current-row @current-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column width="600" prop="name" label="流程名称" :show-overflow-tooltip="true"></el-table-column>
                                   <el-table-column    label="流程状态" > 
                                    <template slot-scope="scope">
                                        <el-tag type="success" v-if="scope.row.hasOwnProperty('endTime')" >已完成</el-tag>
                                        <el-tag  v-else >进行中</el-tag>
                                    </template>
                                  </el-table-column>
                                </el-table>
                            </template>
                          <!-- 分页 -->
                          <el-row type="flex" justify="end">
                              <el-pagination
                                  background
                                  layout="total, prev, pager, next"
                                  :total="totalPageNumInDept"
                                  :current-page="currentPageInDept"
                                  :page-size="pageSizeInDept"
                                  @current-change="queryFormDataInDept"
                                  >
                              </el-pagination>
                          </el-row>
                      </el-aside>
                      <el-aside style="width: 40%">
                          <div class="tools-bar">
                              <span><el-tag type="success">已选择的流程</el-tag></span>
                              <div class="tools-btn-group">
                                  <el-button icon="el-icon-remove" type="danger" @click="handleRemoveselectedProcess">移除</el-button>
                              </div>
                          </div>
                          <el-table ref="multipleTable" :data="selectedProcessList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" stripe>
                              <el-table-column type="selection" width="55"></el-table-column>
                              <el-table-column prop="name" label="流程名称"></el-table-column>
                          </el-table>
                      </el-aside>
                  </el-container>            
              </el-main>
          </el-container>
          <span style="float: right; margin-top: -3px" slot="footer" class="dialog-footer" v-if="!hideBtn">
                <el-button @click="isInnerShowUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
      <!-- </el-dialog> -->
    </div>
</template>

<script>
    import { getBusinessTreeList, getProcessTimeTreeList, getAllProcessInstanceList, getProcessTemplateList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import { isEmpty, cloneDeep } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department
        },
        data () {
            return {
                processInstanceModel: {},
                isInnerShowUserOrg: false,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                processName: '', // 分配在此部门内流程
                processServiceId: '', // 流程模板
                pState: 1, // 流程状态
                inDpetloading: false,
                processListInBusiness: [], // 分配在此部门内流程
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 8, // 每页条数
                totalPageNumInDept: 1, // 总页数

                empNameUnInDept: '',
                selectedProcessList: [], // 已选择的流程列表数据
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 8, // 每页条数
                totalPageNumUnInDept: 1, // 总页数
                processState: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }
                    // , {
                    //     value: 4,
                    //     label: '已终止'
                    // }
                ],
                selectMap: new Map(),
                currentBusinessId: '', // 当前点击的业务分类树
                selectedProcessIds: '', // 选中的流程ID
                selectedProcessNames: '', // 选中的流程名称
                selectedRemovedUserIds: '', // 选中的流程ID
                currentTemplateList: [],
                loadTimer: new Date().getTime()
            };
        },
        props: {
            selectedProcess: {
                type: Object,
                default: function () {
                    return {
                        selectedProcessIds: '',
                        selectedProcessNames: ''
                    };
                }
            },
            isShowProcessPop: {
                type: Boolean,
                default: false
            },
            filterUsers: {// 需要过滤不显示的人员信息
                type: String,
                default: ''
            },
            multiple: {
                type: Boolean,
                default: false
            },
            field: { // 自定义属性字段
                type: Object
            },
            formData: {// 自定义属性表单数据
                type: Object
            },
            hideBtn: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                // this.isInnerShowUserOrg = this.isShowProcessPop;
                this.selectMap = new Map();
                if (!isEmpty(this.selectedProcess.selectedProcessIds)) {
                    this.selectedProcessIds = this.selectedProcess.selectedProcessIds;
                    this.selectedProcessNames = this.selectedProcess.selectedProcessNames;
                    await this.handleSearchUnInDept();
                }
                // console.log("============"+this.selectedProcessIds);
                // this._getListData();
                // this._getTreeData();
                await this.initProcessTemplateList();
                await this.handleSearchInDept();
            },
            async initProcessTemplateList () {
                let param = {
                    state: 1,
                    unNeedAuth: this.unNeedAuth,
                    currentPage: 0,
                    pageSize: 10000
                };
                let { data } = await getProcessTemplateList(param);// 查出最新版本的流程方案
                // this.processTemplateList = data;
                this.currentTemplateList = data;
                this.loadTimer = new Date().getTime();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async _getTreeData () {
                let treeList = await getBusinessTreeList();
                this.treeData = treeList;
                this.isShowTree = true;
            },
            handleTreeNode (data, node, tree) {
                this.currentBusinessId = data.id;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
                // 初始化变量
                // this.selectedProcessIds = '';
                // this.selectedRemovedUserIds = '';
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                // let processListData = await getProcessInstancesList({
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                // let processListData = await getProcessTimeTreeList({
                let processListData = await getAllProcessInstanceList({
                    pageSize: this.pageSizeInDept,
                    currentPage: this.currentPageInDept,
                    serviceName: this.processName,
                    processServiceId: this.processServiceId,
                    currentBusinessId: this.currentBusinessId,
                    allProcessInstance: true,
                    filterAll: true,
                    state: this.pState // 默认查当前登录人参与的全部流程
                });
                loading.close();
                if (processListData) {
                    let sourceUser = cloneDeep(processListData.data);
                    let filterUser = [];
                    // console.log(sourceUser);
                    if (!isEmpty(this.selectedProcess.selectedProcessIds)) {
                        let selectedIds = this.selectedProcess.selectedProcessIds.split(',');
                        for (let j = 0; j < selectedIds.length; j++) {
                            this.selectMap.set(selectedIds[j], selectedIds[j]);
                        }
                    }
                    if (!isEmpty(this.filterUsers)) {
                        let filterIds = this.filterUsers.split(',');
                        let filterMap = new Map();
                        for (let j = 0; j < filterIds.length; j++) {
                            filterMap.set(filterIds[j], filterIds[j]);
                        }
                        for (let i = 0; i < sourceUser.length; i++) {
                            if (!filterMap.has(sourceUser[i].id)) {
                                filterUser.push(sourceUser[i]);
                            }
                        }
                    } else {
                        filterUser = sourceUser;
                    }
                    // console.log(filterUser);
                    this.processListInBusiness = filterUser;
                    // this.processListInBusiness = processListData.data;
                    this.currentPageInDept = processListData.page;
                    this.pageSizeInDept = processListData.pageSize;
                    this.totalPageNumInDept = processListData.totalPageNum;
                    this.inDpetloading = false;
                }
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            async handleSearchUnInDept () {
                // console.log(this.selectedProcessIds);
                // this.unInDpetloading = true;
                if (!isEmpty(this.selectedProcessIds)) {
                    let ids = this.selectedProcessIds.split(',');
                    let names = this.selectedProcessNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], name: names[i]});
                    }
                    this.selectedProcessList = selectedData;
                } else {
                    this.selectedProcessList = [];
                }
                // this.unInDpetloading = false;
            },
            // queryFormDataUnInDept (currentPageUnInDept) {
            //     this.currentPageUnInDept = currentPageUnInDept;
            //     this._getListData();
            // },
            async handleRemoveselectedProcess () {
                if (!isEmpty(this.selectedRemovedUserIds)) {
                    let newIds = this.selectedRemovedUserIds.split(',');
                    let ids = this.selectedProcessIds.split(',');
                    let names = this.selectedProcessNames.split(',');
                    let selectedData = [];
                    this.selectedProcessIds = '';
                    this.selectedProcessNames = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], name: names[i]});
                            if (isEmpty(this.selectedProcessIds)) {
                                this.selectedProcessIds = ids[i];
                                this.selectedProcessNames = names[i];
                            } else {
                                this.selectedProcessIds = this.selectedProcessIds + ',' + ids[i];
                                this.selectedProcessNames = this.selectedProcessNames + ',' + names[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedProcessList = selectedData;
                    // this.selectedProcess.selectedProcessIds = this.selectedProcessIds;
                    // this.selectedProcess.selectedProcessNames = this.selectedProcessNames;
                }
            },
            handleSelectionChangeInDept (rows) {
                // this.selectedProcessIds = '';
                // this.selectedProcessNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedProcessIds)) {
                                        this.selectedProcessIds = row.id;
                                        this.selectedProcessNames = row.name;
                                    } else {
                                        this.selectedProcessIds = this.selectedProcessIds + ',' + row.id;
                                        this.selectedProcessNames = this.selectedProcessNames + ',' + row.name;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedProcessIds = rows.id;
                        this.selectedProcessNames = rows.name;
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedUserIds)) {
                                this.selectedRemovedUserIds = row.id;
                            } else {
                                this.selectedRemovedUserIds = this.selectedRemovedUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            async changeProcessList () {
                this.currentPageInDept = 1;
                this.handleSearchInDept();
            },
            confirmClick () {
                this.selectedProcess.selectedProcessIds = this.selectedProcessIds;
                this.selectedProcess.selectedProcessNames = this.selectedProcessNames;
                if (this.formData) {
                    this.formData[this.field.formField] = this.selectedProcess.selectedProcessIds;
                    this.formData[this.field.formField + '-view'] = this.selectedProcess.selectedProcessNames;
                }
                this.$emit('nodeClick', this.selectedProcess);
                this.isInnerShowUserOrg = false;
                return this.selectedProcess;
            }
        }
    };
</script>

<style lang="less">
    .userOrgPop {
        // height: 430px;
        height: 70vh;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ProcessSelectPop/ProcessSelectPop.vue